export default __webpack_public_path__ + "static/media/small-scale-solution.5326ba63.png";